// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"26":"7b7835d8","43":"de5d56cf","442":"8fa47a59"}[chunkId] + ".chunk.css";
};